import React from "react";

const RemoveBannerSlider = () => {
  return <div>RemoveBannerSlider</div>;
};

export default React.memo(RemoveBannerSlider);
